// extracted by mini-css-extract-plugin
export var centerText = "_5e-8";
export var container = "_5e-0";
export var doughnutContainer = "_5e-7";
export var legend = "_5e-a";
export var legendItemColorDisplay = "_5e-b";
export var legendItemLabel = "_5e-d";
export var legendItemValue = "_5e-c";
export var lg = "_5e-5";
export var maxWidth = "_5e-9";
export var md = "_5e-4";
export var responsive = "_5e-6";
export var sm = "_5e-3";
export var xs = "_5e-2";
export var xxs = "_5e-1";